import { Modal } from '@trackman/web-shared-components';
import './LearnMoreDialog.scss';
import { useTranslation } from 'react-i18next';
import Subtitle from 'components/TextComps/Subtitle';
import { ReactComponent as Medal } from 'images/icons/MedalThin.svg';
import { ReactComponent as Checkmark } from 'images/icons/CheckmarkThin.svg';
import { ShopCertificate } from 'types/pricing';
import Paragraph from 'components/TextComps/Paragraph';
import { ReactComponent as CheckmarkCircle } from 'images/icons/CheckmarkCircle.svg';

type Props = {
  open: boolean;
  certification: ShopCertificate;
  isItemInCart: boolean;
  isItemLocked: boolean;
  onClose: () => void;
  onAddToCart?: (id: string) => void;
};

export const LearnMoreDialog = ({ open, certification, isItemInCart, isItemLocked, onClose, onAddToCart }: Props) => {
  const { t } = useTranslation();

  const handleAddToCart = () => {
    if (onAddToCart) {
      onAddToCart(certification.id);
    }
  };


  return (
    <Modal
      className='certificate-learn-more-modal'
      cancelBtn={{
        label: t('Close', { ns: 'webshop' }),
        onClick: onClose,
      }}
      confirmBtn={
        isItemLocked
          ? undefined
          : isItemInCart
            ? {
                label: t('AddedToCart', { ns: 'webshop' }),
                className: 'added-to-cart-button',
                startIcon: <CheckmarkCircle className='added-to-cart-button-icon' />,
              }
            : {
                label: t('AddToCart', { ns: 'webshop' }),
                onClick: handleAddToCart,
              }
      }
      onClose={onClose}
      title={t('CertificateOverview', { ns: 'certificationExamDescriptions' })}
      open={open}
    >
      <div className='certification-learn-more-header'>
        <Paragraph>
          <>{t('CertificationExam', { ns: 'certificationExamDescriptions' })}</>
        </Paragraph>
        <div>
          <Medal />
          <Subtitle>
            <>{certification.title}</>
          </Subtitle>
        </div>
        <Paragraph>
          <>{certification.description}</>
        </Paragraph>
      </div>

      <div className='certification-learn-more-content'>
        <div className='certification-learn-more-section'>
          <Subtitle>
            <>{t('AboutTrackmanCertifications', { ns: 'certificationExamDescriptions' })}</>
          </Subtitle>
          <div>{t('AboutLine1', { ns: 'certificationExamDescriptions' })}</div>
          <div>{t('AboutLine2', { ns: 'certificationExamDescriptions' })}</div>
        </div>

        <div className='certification-learn-more-section'>
          <Subtitle>
            <>{t('WhatYouWillGet', { ns: 'certificationExamDescriptions' })}</>
          </Subtitle>
          <div className='certification-learn-more-benefits'>
            <div className='certification-learn-more-benefit-item'>
              <Checkmark className='benefit-icon' />
              {t('OfficialTrackmanCertifiedCredential', { ns: 'certificationExamDescriptions' })}
            </div>

            <div className='certification-learn-more-benefit-item'>
              <Checkmark className='benefit-icon' />
              {t('DataDrivenCoachingSkills', { ns: 'certificationExamDescriptions' })}
            </div>

            <div className='certification-learn-more-benefit-item'>
              <Checkmark className='benefit-icon' />
              {t('RecognitionWithinTheTrackmanCoachingCommunity', { ns: 'certificationExamDescriptions' })}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
